import { render, staticRenderFns } from "./OverviewPages.vue?vue&type=template&id=4d80bc12&scoped=true&"
import script from "./OverviewPages.vue?vue&type=script&lang=js&"
export * from "./OverviewPages.vue?vue&type=script&lang=js&"
import style0 from "./OverviewPages.vue?vue&type=style&index=0&id=4d80bc12&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4d80bc12",
  null
  
)

export default component.exports